/*
 ** Import Swiper js moduls
 ** Created by @ahmad.gharaibeh@brande.ue
 ** Core version + navigation, pagination modules:
 */
// import Swiper, { Navigation, Pagination, Lazy } from "swiper";
import Swiper from "../../node_modules/swiper/core/core.js";
import Navigation from "../../node_modules/swiper/modules/navigation/navigation.js";
import Pagination from "../../node_modules/swiper/modules/pagination/pagination.js";

/*
 ** Swiper js function for initialize [ Product ] slider
 ** Created by @ahmad.gharaibeh@brande.ue
 */
var swiper = new Swiper(".product-swiper", {
  modules: [Pagination],
  slidesPerView: 1.25,
  spaceBetween: 10,
  pagination: {
    el: ".product-swiper .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});

/*
 ** Swiper js function for initialize [ Product ] slider
 ** Created by @ahmad.gharaibeh@brande.ue
 */
var swiper = new Swiper(".partners-swiper .swiper", {
  modules: [Pagination, Navigation],
  slidesPerView: 2,
  spaceBetween: 10,
  pagination: {
    el: ".partners-swiper .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".partners-swiper .swiper-button-next",
    prevEl: ".partners-swiper .swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

export const Slider = [];
